import { useState } from "react";
import { Listing, LocationData } from "../../../types";
import { Email } from "../../icons/Email";
import { Instagram } from "../../icons/Instagram";
import { ContactForm } from "../../ContactForm/ContactForm";
import ReactMarkdown from "react-markdown";
import { useEditMode } from "../../../hooks/useEditMode";
import "./DetailSidebar.css";

type DetailSidebarProps = {
  listing: Listing;
  location: LocationData | null;
  hasContactForm?: boolean;
  creatorIds?: string[];
};

export const DetailSidebar = ({
  listing,
  location,
  hasContactForm,
  creatorIds = [],
}: DetailSidebarProps) => {
  const [showContactForm, setShowContactForm] = useState(false);

  // Extract Instagram handle from socialLinks
  const getInstagramHandle = () => {
    if (!listing.socialLinks || !Array.isArray(listing.socialLinks))
      return null;
    const instagram = listing.socialLinks.find(
      (link) => link.platform === "instagram"
    );
    return instagram?.url || null;
  };

  const instagramHandle = getInstagramHandle();

  return (
    <>
      <aside className="listing-sidebar">
        {listing.imageUrl && (
          <div className="listing-profile-image">
            <img src={listing.imageUrl} alt={listing.name} />
          </div>
        )}

        <h1 className="listing-name">{listing.name}</h1>

        {listing.url && (
          <a
            href={listing.url}
            target="_blank"
            rel="noopener noreferrer"
            className="listing-website-link"
          >
            {listing.url.replace(/^https?:\/\//, "")}
          </a>
        )}

        {listing.description && (
          <div className="listing-description">
            <ReactMarkdown>{listing.description}</ReactMarkdown>
          </div>
        )}

        {location && (
          <div className="listing-location">
            <span className="listing-location-icon">📍</span>
            <span>{location.placeName}</span>
          </div>
        )}

        {(instagramHandle || (hasContactForm && listing.email)) && (
          <div className="listing-social-links">
            {instagramHandle && (
              <a
                href={`https://instagram.com/${instagramHandle}`}
                target="_blank"
                rel="noopener noreferrer"
                className="listing-social-icon"
                aria-label="Instagram"
              >
                <Instagram size={24} />
              </a>
            )}
            {hasContactForm && listing.email && (
              <button
                className="listing-social-icon"
                onClick={() => setShowContactForm(true)}
                aria-label="Contact"
              >
                <Email size={24} />
              </button>
            )}
          </div>
        )}
      </aside>
      {showContactForm && (
        <ContactForm
          recipientName={listing.name}
          recipientId={listing.id}
          onClose={() => setShowContactForm(false)}
        />
      )}
    </>
  );
};
